import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { checkFileValidation } from "../../Utils/Common";

const Edit_company = (props) => {
  document.title = "Edit Company";
  const history = useHistory();
  const { postRequest, postRequestByFormData } = useRequests();

  const [AlertData, setAlertData] = useState({ variant: '', message: '' });
  const [selectedLang, setSelectedLang] = useState("eng");
  const [langData, setLangData] = useState({
    eng: { name: "", code: "", logo: "" },
    es: { name: "", code: "", logo: "" }
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({ variant: '', message: '' });
    }, 5000);
  };

  const validationSchema = Yup.object({
    enName: Yup.string().required("Company Name is required"),
    enCode: Yup.string().required("Company Code is required"),
    // esName: Yup.string().required("Company Name is required"),
    // esCode: Yup.string().required("Company Code is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      enName: langData.eng.name,
      enCode: langData.eng.code,
      // esName: langData.es.name,
      // esCode: langData.es.code,
    },
    validationSchema,
    onSubmit: async () => {
      try {
        if (FileName === '') {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: 'Please select a document!',
            }));
            return;
        }
        const formData = new FormData();
          
        formData.append("file", File);
        formData.append("fileName", FileName);

        const payload = [
          { lang: localStorage.getItem("I18N_LANGUAGE"), name: langData.eng.name, code: langData.eng.code, com_id: atob(props.match.params.id) },
          // { lang: "es", name: langData.es.name, code: langData.es.code }
        ];
        formData.append("payload", JSON.stringify(payload));

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const res = await postRequestByFormData('update-company', formData);
        if (res && res.code === 200) {
          history.push({
            pathname: '/company_management',
            state: { code: 200, status: 'success', message: res.message }
          });
        } else {
          setAlertData({ variant: 'error', message: res.message });
        }
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const handleLangChange = (lang) => setSelectedLang(lang);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    const currentLang = selectedLang;
    setLangData((prev) => ({
      ...prev,
      [currentLang]: { ...prev[currentLang], [name]: value }
    }));
    formik.setFieldValue(
      `${currentLang}${name.charAt(0).toUpperCase() + name.slice(1)}`,
      value
    );
  };

  const handleLoadGetCompanyInfo = async () => {
    const jsonpar = JSON.stringify({
      com_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-company-info', jsonpar);

    if (res && res.code === 200 && Array.isArray(res.data)) {
      let updatedData = { eng: { name: "", code: "" }};

      updatedData.eng = { name: res.data[0].name, code: res.data[0].code, logo: res.data[0].logo };

      // res.data[1].forEach(item => {
      //   if (item.lang === "es") updatedData.es = { name: item.name, code: item.code };
      // });

      setLangData(updatedData);
      formik.setValues({
        enName: updatedData.eng.name,
        enCode: updatedData.eng.code,
        // esName: updatedData.es.name,
        // esCode: updatedData.es.code
      });
    } else {
      setAlertData({ variant: 'error', message: res.message });
      resetAlertData();
    }
  };

  useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/company_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
    } else {
      handleLoadGetCompanyInfo();
    }
  }, []);

    const [File, setFile] = useState();
    const [FileName, setFileName] = useState('');
    const saveFile = (e) => {
      if((e.target.files).length > 0) {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
  
        var validationRes = checkFileValidation(e.target.files[0]);
        if (!validationRes.status) {
          setFile();
          setFileName('');
  
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: validationRes.msg,
          }));
          resetAlertData();
  
          return false;
        }
      }
    };

  return (
    <React.Fragment>
      {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Edit Company")} />
          <Card>
            <CardBody>
              {/* <Row>
                <Col md={4}>
                  <Label className="form-label">Select Language:</Label>
                  <Input
                    type="select"
                    value={selectedLang}
                    onChange={(e) => handleLangChange(e.target.value)}
                  >
                    <option value="eng">English</option>
                    <option value="es">Spanish</option>
                  </Input>
                </Col>
              </Row> */}
              <Row className="mt-3">
                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Company Name :
                    </Label>
                    <Input
                      name="name"
                      type="text"
                      placeholder={`Enter Company Name (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].name}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched[`${selectedLang}Name`] &&
                        formik.errors[`${selectedLang}Name`]
                      }
                    />
                    {formik.touched[`${selectedLang}Name`] &&
                      formik.errors[`${selectedLang}Name`] && (
                        <FormFeedback type="invalid">
                          {formik.errors[`${selectedLang}Name`]}
                        </FormFeedback>
                      )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Company Code :
                    </Label>
                    <Input
                      name="code"
                      type="text"
                      placeholder={`Enter Company Code (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].code}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched[`${selectedLang}Code`] &&
                        formik.errors[`${selectedLang}Code`]
                      }
                    />
                    {formik.touched[`${selectedLang}Code`] &&
                      formik.errors[`${selectedLang}Code`] && (
                        <FormFeedback type="invalid">
                          {formik.errors[`${selectedLang}Code`]}
                        </FormFeedback>
                      )}
                  </div>
                </Col>
<Col md={6}>
  <div className="mb-3">
    <label className="form-label">Logo :</label>

    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
      
      {langData[selectedLang].logo && (
        <img
          src={langData[selectedLang].logo}
          alt="Company Logo"
          style={{
            width: "120px",
            height: "120px",
            objectFit: "contain",
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "5px",
            background: "#fff"
          }}
        />
      )}

      <div style={{ flex: 1 }}>
        <Input
          type="file"
          className="form-control"
          onChange={saveFile}
          accept=".pdf,.jpg,.jpeg,.png"
        />
      </div>

    </div>
  </div>
</Col>
              </Row>
              <div className="text-left mt-2">
                <button
                  type="button"
                  id="submit1"
                  onClick={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                  }}
                  className="btn btn-primary me-2"
                >
                  Update
                </button>
                <Link to="/company_management" className="btn btn-light me-2">Cancel</Link>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Edit_company);
